var map = {
	"./IMG_6388.jpg": 2456,
	"./IMG_6389.jpg": 6773,
	"./IMG_6390.jpg": 8687,
	"./IMG_6391 2.jpg": 2472,
	"./IMG_6392.jpg": 6205,
	"./IMG_6393.jpg": 5072,
	"./IMG_6394.jpg": 7907,
	"./IMG_6395.jpg": 1446,
	"./IMG_6485.jpg": 2090,
	"./IMG_6486.jpg": 7813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8902;